export enum SANDBOX_ACTIONS {
  SET_IS_SANDBOX = 'SANDBOX_ACTIONS.SET_IS_SANDBOX',
}

export type SetIsSandbox = {
  type: typeof SANDBOX_ACTIONS.SET_IS_SANDBOX
  isSandbox: boolean
}

export type ActionTypes = SetIsSandbox
